/** Preload sanity image "asIs" this should be used for things like background images or images that are not directly rendered in the DOM.
 * @see PtcPicture.vue for examples of loading "normal" images with srcsets and sizes attributes.
 */
export const preloadImgSrc = (imgSrc: string) => {
  // Use Nuxt's useHead to preload the image
  useHead({
    link: [
      {
        rel: 'preload',
        as: 'image',
        href: imgSrc,
      },
    ],
  });
};
